import React from 'react'
import ContactForm from './ContactForm'

export const ContactUsView = () => (
  <div>
    <h1 className={'page-title'}>Contact us</h1>
    <p>
      Fill out the form and a Xooker representative will contact you via email. If you'd like a phone call, provide your
      phone number.
    </p>
    <p>
      Phone: 844-523-9487
    </p>
    <p>
      Email: INFO@XOOKER.COM
    </p>
    <ContactForm />
  </div>
)

export default ContactUsView



// WEBPACK FOOTER //
// ./src/routes/ContactUs/components/ContactUsView.js